import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScreenUsers, faFileMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import {
  faFolderPlus,
  faFolderTree,
  faRocket,
  faFileLines,
  faSitemap,
  faPersonChalkboard,
  faChartArea,
  faPlay
} from '@fortawesome/free-solid-svg-icons';

export const items = [
  {
    background: 'linear-gradient(180deg, #62CFFE 0%, #0C8DC5 100%)',
    icon: <FontAwesomeIcon size="2xl" icon={faFileMagnifyingGlass} />,
    name: 'Browse Content',
    iconColor: '#3DB2E5',
    path: '/questionsSearch',
    comingSoon: false
  },
  {
    background: 'linear-gradient(180deg, #59C9A8 0%, #2CA07E 100%)',
    icon: <FontAwesomeIcon size="2xl" icon={faFolderPlus} />,
    name: 'Create Assignment',
    iconColor: '#44B694',
    path: '/assignments',
    comingSoon: false
  },
  {
    background: 'linear-gradient(180deg, #A29BFE 0%, #4F46BD 100%)',
    icon: <FontAwesomeIcon size="2xl" icon={faFolderTree} />,
    name: 'My Content',
    iconColor: '#746CDA',
    path: '/mycontent',
    comingSoon: false
  },
  {
    background: 'linear-gradient(180deg, #FFD600 0%, #A99115 100%)',
    icon: <FontAwesomeIcon size="2xl" icon={faChartArea} />,
    name: 'Reports',
    iconColor: '#B89D11',
    path: '/reports',
    comingSoon: false
  },
  {
    background: 'linear-gradient(180deg, #0984E3 0%, #004478 100%)',
    icon: <FontAwesomeIcon size="2xl" icon={faScreenUsers} />,
    name: 'My Classes',
    iconColor: '#0466B1',
    path: '/classes',
    comingSoon: false
  },
  {
    background: 'linear-gradient(180deg, #FD79A8 0%, #A72D59 100%)',
    icon: <FontAwesomeIcon size="2xl" icon={faSitemap} />,
    name: 'Assignment List',
    iconColor: '#CC4F7C',
    path: '/assignments',
    comingSoon: false
  }
];

export const helpeResource = [
  {
    title: 'Getting Started',
    navigate:'https://hes-nextcloud.harriscomputer.io/index.php/s/z3D3bSycPmLsN5R ',
    icon: <FontAwesomeIcon icon={faRocket} />,
    background: 'linear-gradient(90deg, #63D0FF 0%, #33ADE1 100%)',
    iconColor: '#63D0FF',
    target: '_blank'
  },
  {
    title: 'Help Resource Documents',
    navigate: 'https://www.castlelearning.com/help-resource-documents-for-teachers',
    icon: <FontAwesomeIcon icon={faFileLines} />,
    background: 'linear-gradient(90deg, #59C9A8 -0.44%, #2FB48D 100%)',
    iconColor: '#59C9A8',
    target: '_blank'
  },
  {
    title: 'Video Tutorials',
    navigate: 'https://www.castlelearning.com/video-tutorials/',
    icon: <FontAwesomeIcon icon={faPlay} />,
    background: 'linear-gradient(89.94deg, #E17055 0.04%, #D35233 99.94%)',
    iconColor: '#E17055',
    target: '_blank'
  },
  {
    title: 'Webinars',
    navigate:
      'https://harriseducationsolutions.com/castle-webinar-page/',
    icon: <FontAwesomeIcon icon={faPersonChalkboard} />,
    background: 'linear-gradient(90deg, #A29BFE 0.74%, #746AFF 104.12%)',
    iconColor: '#A29BFE',
    target: '_blank'
  }
];
